const checked = value => value === true

export { checked }
